<template>
    <div class="container">
        <div id="category-picker">
            <div v-for="(category, index) in categories"
                 :key="index"
                 :class="{'category-entry': true,
                          'selected': category === selectedCategory}"
                 @click="selectCategory(category)">
                {{category.title}}
            </div>
        </div>
        <div id="items-editor"
             v-if="selectedCategory">
            <div id="items-container">
                <div v-for="(item, index) in selectedCategory.items"
                     :key="index"
                     :class="{'item': true,
                              'selected': item === selectedItem}"
                     @click="selectItem(item)">
                    {{item}}
                </div>
            </div>
            <div id="items-control"
                 :class="{disabled: this.deleting}">
                <div class="button" @click="showAdd">添加</div>
                <div class="button" @click="deleteItem">删除</div>
            </div>
        </div>
        <div id="dialog-mask"
             v-show="dialogVisible">
            <div id="add-dialog"
                 :class="{disabled: this.adding}">
                <h2>添加项目</h2>
                <link-picker id="link-picker"
                             data=""
                             :visible="['产品页', '自定义']"
                             ref="product-picker"/>
                <div id="dialog-buttons">
                    <div class="button" @click="dismissModal">取消</div>
                    <div class="button" @click="addItem">添加</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import LinkPicker from "../components/form/LinkPicker";
	import CategoryService from "../services/CategoryService";

	export default {
		name: "Categories",
		components: {LinkPicker},
        created() {
			this.loadItems();
        },
		data() {
			return {
				categories: [],
				selectedCategory: null,
				selectedItem: null,
				dialogVisible: false,
				adding: false,
				deleting: false
			}
		},
		methods: {
			selectCategory(cat) {
				this.selectedItem = null;
				this.selectedCategory = cat;
			},
			selectItem(item) {
				this.selectedItem = item
			},
            async loadItems() {
				this.categories = await CategoryService.getItems();
            },
			async addItem() {
				if (this.adding) {
					return;
				}
				let val = this.$refs["product-picker"].getValue().trim();
				if (!val.startsWith("/details/")) {
					if (val === "" || !alert("这不是产品页链接，无法添加。")) {
						return;
                    }
				}
                let id = val.substring(9);
				console.log(id);
                let cat = this.selectedCategory;
                if (id in cat.items) {
                    alert("该类别已经包含该产品");
                }
                this.adding = true;
                let result = await CategoryService.addItem(cat.index, cat.lang, id);
                if (result.status === "success") {
                    alert("添加成功");
                    cat.items.push(id);
                }
                this.adding = false;

				this.dismissModal();
			},
			async deleteItem() {
				if (this.deleting || !this.selectedItem ||
                    !confirm(`确定要删除"${this.selectedItem}"吗？`)) {
					return;
                }
				let id = this.selectedItem;
				let cat = this.selectedCategory;
				this.deleting = true;
				let result = await CategoryService.deleteItem(cat.index, cat.lang, id);
				if (result.status === "success") {
					alert("删除成功");
					cat.items = cat.items.filter(x => x !== id);
				}
				this.deleting = false;
				this.selectedItem = null;
			},
			showAdd() {
				if (!this.deleting && this.selectedCategory !== null) {
					this.dialogVisible = true;
				}
			},
			dismissModal() {
				this.dialogVisible = false;
			}
		}
	}
</script>

<style scoped lang="scss">
    .container {
        padding: 64px;
        display: flex;
    }

    #category-picker {
        width: 240px;
        height: 100%;
        overflow-y: scroll;
    }

    #items-editor {
        flex-grow: 1;
    }

    #items-container {
        margin-left: 48px;
        display: flex;
        flex-flow: column wrap;
        overflow-x: scroll;
        align-content: flex-start;
        height: calc(100% - 64px);
    }

    #items-control {
        display: flex;
        justify-content: flex-start;
        margin-left: 52px;

        .button {
            width: 64px;
            margin-right: 8px;
        }
    }

    .category-entry, .item {
        height: 44px;
        line-height: 44px;
        padding: 0 8px;
        margin: 4px 0;
        cursor: pointer;
        box-sizing: border-box;
    }

    .category-entry {
        border-right: $dotted;
        font-family: $serif;
        text-align: right;
    }

    .item {
        min-width: 240px;
        max-width: 360px;
        border: $solid;
        margin: 4px;
    }

    .category-entry:hover, .category-entry.selected,
    .item:hover, .item.selected {
        background-color: $p-fg;
        color: $p-bg;
    }

    .category-entry.selected {
        border-right: solid 4px $p-accent;
    }

    #dialog-mask {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
        background-color: transparentize($p-fg, 0.5);
    }

    #add-dialog {
        display: flex;
        position: absolute;
        flex-direction: column;
        box-sizing: border-box;
        animation: modal-show 0.5s $bezier;
        background-color: $p-bg;
        border: $solid;
        left: 25vw;
        top: 15vh;
        height: 70vh;
        width: 50vw;
        padding: 24px 32px;
        box-shadow: $p-accent 0 16px 0 -8px;
    }

    @keyframes modal-show {
        from {
            opacity: 0;
            transform: translateY(-2em);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    h2 {
        font-family: $serif;
    }

    #link-picker {
        flex-grow: 1;
        margin-bottom: 8px;
        overflow: scroll;
        resize: unset;
    }

    #dialog-buttons {
        display: flex;
        justify-content: flex-end;

        .button {
            width: 64px;
            margin-left: 8px;
        }
    }

    .disabled {
        .button {
            cursor: not-allowed;
            color: $d-fg;
            filter: grayscale(1);
        }

        .button:hover {
            background-color: $p-bg;
            color: $d-fg;
        }

        .button:active {
            transform: unset;
        }
    }
</style>